export * as buildingDepreciation from './building-depreciation'
export * as collegeAdministration from './college-administration'
export * as departmentAdministration from './department-administration'
export * as equipmentDepreciation from './equipment-depreciation'
export * as generalAdministration from './general-administration'
export * as instruction from './instruction'
export * as interest from './interest'
export * as library from './library'
export * as operationsAndMaintenance from './operations-and-maintenance'
export * as organizedResearch from './organized-research'
export * as otherInstitutionalActivities from './other-institutional-activities'
export * as otherSponsoredActivities from './other-sponsored-activities'
export * as sponsoredProjectAdministration from './sponsored-project-administration'
export * as studentAdministrativeServices from './student-administrative-services'
